// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".sidebar--2mM6g{background:#f9f9f9;box-sizing:border-box;display:flex;flex-direction:column;height:100%;left:0;overflow-y:scroll;position:relative;width:100%}\n", ""]);
// Exports
exports.locals = {
	"sidebar": "sidebar--2mM6g"
};
module.exports = exports;
